import dayjs from 'dayjs';
import React, { FC } from 'react';

import { ReactComponent as GpsIcon } from '../../assets/gps-location.svg';
import { ReactComponent as GsmIcon } from '../../assets/gsm-location.svg';
import celltowericon from '../../assets/cell-tower-icon.png';
import sateliteIcon from '../../assets/satelite.png';
import { DataTextBody } from '../data-text-body/data-text-body.component';
import { SleeperReportingMode } from '../../services/api/models/SleeperReportingMode';
import { LocationType } from '../../services/api/models/LocationType';
import CSS from 'csstype';

const divFlexStyles: CSS.Properties = {
    flexWrap: 'wrap'
};

type Props = {
    reportDate: string | null | undefined;
    communicationDate: string | null | undefined;
    isGsm?: LocationType | null | undefined;
    registration?:  string | null | undefined;
    enlarge?: boolean;
    useLighterDataFont?: boolean;
};

export const ReportDateTimeDisplay: FC<Props> = ({ reportDate, communicationDate, isGsm, registration, enlarge, useLighterDataFont }) => (
    <div className={`flex flex-row justify-start gap-2 md:gap-4 ${enlarge ? 'justify-between' : ''}`} style={ divFlexStyles }>
        <div className="flex flex-row items-center gap-1 md:gap-2">

            <div className='pt-1'>
                <p style={{ color: 'darkgreen', fontSize: 15 }} >Registration</p>
                <DataTextBody useLightFont={useLighterDataFont}>{registration ? registration : 'NA'}</DataTextBody>

            </div>
        </div>
        <div className="flex flex-row items-center gap-1 md:gap-2">

            <div className='pt-1'>
                <p style={{ color: 'darkgreen', fontSize: 15 }} >Communicated</p>
                <DataTextBody useLightFont={useLighterDataFont}>{communicationDate ? dayjs(communicationDate).format('DD/MM/YY HH:mm:ss') : 'Unknown'}</DataTextBody>

            </div>
        </div>

 
        <div className="flex flex-row items-center gap-1 md:gap-2">

                <div className='pt-1'>
                <p style={{ color: 'darkgreen', fontSize: 15 }} >Last Location Time</p>
                    <DataTextBody useLightFont={useLighterDataFont}>{reportDate ? dayjs(reportDate).format('DD/MM/YY HH:mm:ss') : 'Unknown'}</DataTextBody>
            </div>
            {
                reportDate
                    ?
                    isGsm === 'CELL'
                        ?
                        <img src={celltowericon} alt="GSM" height={30} width={30} /> 
                        :
                        <img src={sateliteIcon} alt = "GPS" height={30} width={30} />
                    :
                    <div className='pt-1' />
            }
            </div>
        <div>
        </div>
    </div>
);
